export const TransferDeviceToOrgModalStates = {
	open: false,
	isDisabled: false,
	isLoadingOrg: false,
	data: null,
	selectedOrg: null,
	selectedDevice: null,
	isSuccess: false,
	isLoading: false,
	isError: false,
	errorMessage: null,
	isNotSelected: false,
	staticUIElement: {
		title: null,
		placeholder: null,
		noResultsMessage: null,
		notification:
			"Please note that BifrostConnect support is required to transfer the device back to the reseller organizations or between two customer organizations. The device will be removed from groups, and its events will also be deleted."
	}
}
